// extracted by mini-css-extract-plugin
export default {"container":"DropshipProductCardVariants_container__usw+8","ASC":"DropshipProductCardVariants_ASC__UlK5N","DESC":"DropshipProductCardVariants_DESC__hs2Bk"};